import type { CSSProperties } from 'react';

/**
 * Viewport overlay tokens for full-screen drawers that must dim the app chrome.
 */

/** Stacks above GlobalHeader (`z-1000`) so drawers dim the top bar. */
export const VIEWPORT_OVERLAY_Z_INDEX = 1200;

/**
 * Full-viewport dimmer for side drawers. Covers the header, uses the heavy
 * scrim, and skips backdrop-blur so table/sidebar chrome does not bleed through.
 */
export const viewportOverlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: VIEWPORT_OVERLAY_Z_INDEX,
  background: 'var(--overlay-scrim-heavy)',
  display: 'flex',
  justifyContent: 'flex-end',
};
